<template>
  <section class="m-index-grid m-padding">
      <div class="m-grid" v-if="data.length > 4">
        <router-link :to="{path: item.link, query: {id: item.id}}" class="m-grid-item" v-for="(item,id) in data" :key="id">
          <img :src="item.logo_pic_url" alt="mooby">
          <span>{{item.title}}</span>
        </router-link>
      </div>
  </section>
</template>

<script>
export default {
  name:'IndexGrid',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.m-index-grid {
  background: #fff;
  height:99px;
  width: 100%;
  padding-top: 1px;
  .m-grid {
    margin: 15px 0;
    // margin: 8px 0 8px 0;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    overflow-x: scroll;
    .m-grid-item {
      width: 52px;
      display: flex;
      margin-left: 20.75px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:nth-child(1) {
        margin: 0;
      }
      img {
        width: 45px;
        height: 45px;
      }
      span {
        font-size: 12px;
        font-weight: 400;
        margin-top: 8px;
        color: #0C021D;
        letter-spacing: 0.5px;
        display: inline-block;
        text-align: center;
        width: 78px;
        transform: scale(0.9);
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
</style>